export const WHATSAPP_TEMPLATE_CATEGORIES = [
  'Lead Follow-Up',
  'Marketing',
  'Utility',
  'Authentication',
  'Order Updates',
  'Customer Support',
] as const;

export const WHATSAPP_TEMPLATE_STATUSES = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
] as const;

export const WHATSAPP_TEMPLATE_VARIABLE_SAMPLES: Record<string, string> = {
  customer_name: 'John',
  order_id: 'ORD-12345',
  product_name: 'Linen Jacket',
  amount: '₦5,000',
  delivery_date: 'Tomorrow',
};

export const WHATSAPP_TEMPLATES_PAGE_SIZE = 10;
